import { column, Schema, Table } from '@powersync/web';

const records = new Table(
  {
    vault_id: column.text,
    current_revision_id: column.text,
    conflict_state: column.text,
    deleted_at: column.text,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { byVault: ['vault_id'], byCurrentRevision: ['current_revision_id'] } },
);

const recordRevisions = new Table(
  {
    vault_id: column.text,
    record_id: column.text,
    record_kind: column.text,
    base_revision_id: column.text,
    operation_id: column.text,
    device_id: column.text,
    crypto_version: column.integer,
    wrapped_record_key: column.text,
    wrapped_record_key_nonce: column.text,
    nonce: column.text,
    ciphertext: column.text,
    client_created_at: column.text,
    received_at: column.text,
    revision_state: column.text,
    deleted: column.integer,
    resolves_conflict: column.integer,
  },
  {
    indexes: {
      byRecord: ['record_id'],
      byOperation: ['operation_id'],
      byVaultAndCreated: ['vault_id', 'client_created_at'],
    },
  },
);

const reminders = new Table(
  {
    vault_id: column.text,
    record_id: column.text,
    source_revision_id: column.text,
    due_at: column.text,
    due_date: column.text,
    local_time: column.text,
    timezone: column.text,
    all_day: column.integer,
    recurrence: column.text,
    mode: column.text,
    updated_at: column.text,
  },
  { indexes: { byVaultDue: ['vault_id', 'due_at'], byRecord: ['record_id'], bySourceRevision: ['source_revision_id'] } },
);

const attachments = new Table(
  {
    vault_id: column.text,
    record_id: column.text,
    crypto_version: column.integer,
    object_key: column.text,
    thumbnail_object_key: column.text,
    wrapped_attachment_key: column.text,
    key_nonce: column.text,
    original_nonce: column.text,
    thumbnail_nonce: column.text,
    ciphertext_size: column.integer,
    thumbnail_ciphertext_size: column.integer,
    checksum: column.text,
    thumbnail_checksum: column.text,
    mime_type: column.text,
    original_name_ciphertext: column.text,
    state: column.text,
    created_at: column.text,
    updated_at: column.text,
    deleted_at: column.text,
    purged_at: column.text,
  },
  { indexes: { byRecord: ['record_id'], byVault: ['vault_id'] } },
);

const devices = new Table(
  {
    vault_id: column.text,
    user_id: column.text,
    name: column.text,
    public_key: column.text,
    platform: column.text,
    revoked_at: column.text,
    last_seen_at: column.text,
    created_at: column.text,
  },
  { indexes: { byVault: ['vault_id'] } },
);

const pairingRequests = new Table(
  {
    vault_id: column.text,
    user_id: column.text,
    requesting_device_id: column.text,
    requesting_device_name: column.text,
    requesting_public_key: column.text,
    display_code: column.text,
    wrapped_vrk: column.text,
    state: column.text,
    expires_at: column.text,
    created_at: column.text,
    approved_at: column.text,
  },
  { indexes: { byVaultState: ['vault_id', 'state'] } },
);

const auditEvents = new Table(
  {
    vault_id: column.text,
    user_id: column.text,
    event_type: column.text,
    device_id: column.text,
    metadata: column.text,
    created_at: column.text,
  },
  { indexes: { byVaultCreated: ['vault_id', 'created_at'] } },
);


const searchProjection = new Table(
  {
    vault_id: column.text,
    text: column.text,
    updated_at: column.text,
  },
  { localOnly: true, indexes: { byVault: ['vault_id'] } },
);

const localMetadata = new Table(
  {
    value: column.text,
    updated_at: column.text,
  },
  { localOnly: true },
);

export const AppSchema = new Schema({
  records,
  record_revisions: recordRevisions,
  reminders,
  attachments,
  devices,
  device_pairing_requests: pairingRequests,
  audit_events: auditEvents,
  local_metadata: localMetadata,
  search_projection: searchProjection,
});

export type DatabaseSchema = typeof AppSchema.types;
